module.exports = __webpack_public_path__ + "static/media/palletization.f0b314b0.png";